
import {
    ReactElement,
    useState,
    HTMLAttributes
} from "react";
import { Button } from "./button";
import { AppConstants } from "../../core/constants";

interface Props extends HTMLAttributes<HTMLElement> {
    title: string;
    date: string;
    time: string;
    badge?: any;
    description: string;
    btnTitle: string;
    isDownloadable?: boolean;
    files:any;
    links?:any;
    img?:string
}

export function EducationalCalendar({ title, date, time, badge, description, btnTitle, isDownloadable , files , links , img}: Props): ReactElement {
    const [showDetails, setShowDetails] = useState(false);
    return (
        <div className="educational-calendar">
            <div className="educational-calendar-heading">
                <div className="right-side">
                    <img src={`${AppConstants.base_url_img}/${img}`} className="media-img" alt="هامرز" />
                    <div className="content">
                        <h2 className="title">
                            {title}
                        </h2>
                        <div className="details">
                            <span className="date">{date} <span className="line"> |</span></span>
                            <span className="date">{time}</span>
                            {badge &&
                                <span className="badge">{badge}</span>
                            }

                        </div>
                    </div>
                </div>
                <div className="left-side">

                    <Button onClick={() => isDownloadable ? alert("downloaded") : setShowDetails(!showDetails)} myStyle={`${showDetails ? "left-side-btn-close" : ""} left-side-btn bg-blue`} title={btnTitle} />
                </div>
            </div>
            {showDetails &&

                <div className="educational-calendar-content">
                    <p className="description">
                        {description}
                    </p>
                    <div className="btn-group">
                    {files?.map((item:any, index:number) => {
                                return (
                                    <Button key={index} myStyle="left-side-btn bg-blue" title={item?.subject} onClick={()=>{
                                        window.open(
                                            `${AppConstants.base_url_img}/${item.path}`,
                                            '_blank' 
                                          );
                                    }}/>
                                )
                            })}
                            {links?.map((item:any, index:number) => {
                                return (
                                    <Button key={index} myStyle="left-side-btn bg-blue" title={item?.subject} onClick={()=>{
                                        window.open(
                                            `${item.path}`,
                                            '_blank' 
                                          );
                                    }}/>
                                )
                            })}
                        
                    </div>
                </div>
            }
        </div>
    );
}

export default EducationalCalendar;